import { Col, Row, TabContent, TabPane } from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { NewMessage, Send } from "../../../Constant";
import { EmailComposeForm } from "./EmailComposeForm";

const ComposeMessage = () => {
  return (
    <Col xl="8" md="12" className="box-col-8 pl-0">
      <div className="email-right-aside">
        <div className="email-body radius-left">
          <div className="ps-0">
            <TabContent>
              <TabPane>
                <div className="email-compose">
                  <div className="email-top compose-border">
                    <Row>
                      <Col sm="8" className="xl-50"><H3 className="mb-0">{NewMessage}</H3></Col>
                      <Col sm="4" className="btn-middle xl-50">
                        <Btn color="primary" className="btn-block btn-mail text-center mb-0 mt-0 w-100"><i className="fa fa-paper-plane me-2"></i> {Send}</Btn>
                      </Col>
                    </Row>
                  </div>
                  <div className="email-wrapper">
                    <EmailComposeForm/>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default ComposeMessage;
